/* global document */
/* eslint-disable import/no-unresolved, import/extensions */

import 'babel-polyfill';

import React from 'react';
import { render } from 'react-dom';

import EntryComponent from '../../src/index.js';

render(<EntryComponent />, document.getElementById('app'));
